import { inject, NgZone } from '@angular/core';
import { HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Auth, onAuthStateChanged, User } from '@angular/fire/auth';

function waitForUser(auth: Auth, zone: NgZone): Promise<User | null> {
  return new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, (user) => {
      unsub(); // wichtig, damit der Listener entfernt wird
      zone.run(() => resolve(user));
    });
  });
}

export const httpInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const auth = inject(Auth);
  const zone = inject(NgZone);

  return from(waitForUser(auth, zone)).pipe(
    switchMap(user => {
      return from(user?.getIdToken() || Promise.resolve(null));
    }),
    switchMap((token: string | null) => {
      if (token) {
        req = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });
      }
      return next(req);
    })
  );
};